export default "__VITE_PUBLIC_ASSET__19ee8c42__"